import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import rootSaga from '../bus/rootSaga';
import { omdApi } from './api';
import { rootReducer } from './index';
import { rtkQueryErrorLogger } from './rtkQueryErrorLoger';

const sagaMiddleware = createSagaMiddleware();

const middlewareEnhancer = rtkQueryErrorLogger;
const rtkMiddleware = [middlewareEnhancer, omdApi.middleware];

export const store = configureStore({
  reducer: rootReducer,
  //@ts-ignore
  middleware: (getDefaultMiddleware) =>
    //@ts-ignore
    getDefaultMiddleware({ serializableCheck: false }).concat(rtkMiddleware, sagaMiddleware),
});

sagaMiddleware
  .run(rootSaga)
  .toPromise()
  .catch((e) => {
    console.log('___ROOT SAGA TEST___', e);
  });

export type RootStore = ReturnType<typeof rootReducer>;
